import DownloadImageApi from "../../services/downloadImageService"

export const handleDownload = async (id) => {
    try {
      const imgRes = await DownloadImageApi.getDownloadedImageul(id);
      const response = await fetch(imgRes?.data || "");

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response?.url;
    } catch (error) {
      // console.error("Download failed:", error);
      console.log("Download failed. Please try again later.");
    }
  };


        // Button configurations
 export const actionButtons = [
    {
      type: 'pool-cycles',
      label: 'Pool Cycles',
      variant: 'outlined',
      color: 'primary',
      className: 'hover:bg-[#000] hover:text-[#fff]',
      authority:['start-manufacturing','manufacturing-approve']
    },
    {
      type: 'change-request',
      label: 'Change Request',
      variant: 'contained',
      color: 'primary',
      authority:['manufacturing-approve']
    },
    {
      type: 'terminate',
      label: 'Terminate',
      variant: 'contained',
      color: 'error',
      className: 'bg-[#FF2023] hover:bg-[#000]',
      authority:['manufacturing-approve']
    },
    {
      type: 'approve',
      label: 'Approve Request',
      variant: 'contained',
      color: 'success',
      authority:['manufacturing-approve']
    },
    {
      type: 'reject',
      label: 'Reject Request',
      variant: 'contained',
      color: 'error',
      className: 'bg-[#FF2023] hover:bg-[#000]',
      authority:['manufacturing-approve']
    }
  ];

 export const masterKeys = {
    "terminate": "Terminate Reason",
    "change-request": "Change Request Reason",
    "equipment": "Equipment",
    "logistics-partners":"Logistics Partners",
    "payment":"Payment",
    "payment-type":"Payment Type",
    "download-center":"Download Center"
  }